import { FC, useEffect, useState } from 'react';
import LottieWrapper from './LottieWrapper';
import classNames from 'classnames';
import { ENV_CONFIG } from 'config/environment';
import { defaultOptions, getJSONFile } from './commonOptions';
import * as animationBlueOrbs from 'assets/json/blueOrbs.json';

interface BlueOrbsProps {
  children: React.ReactNode;
  jsonType?: string;
}

const OrbsContainer: FC<BlueOrbsProps> = ({ children, jsonType = 'blueOrbs' }) => {
  const [animationData, setAnimationData] = useState<any>(null);

  useEffect(() => {
    // Fetch the JSON file from the URL
    const fetchAnimationData = async () => {
      try {
        const response = await fetch(
          `${ENV_CONFIG().CLOUD_STORAGE.URL}/json/static_pages/${getJSONFile(jsonType)}.json`
        );
        const jsonData = await response.json();
        setAnimationData(jsonData);
      } catch (error) {
        setAnimationData(animationBlueOrbs);
      }
    };

    fetchAnimationData();
  }, []);

  return (
    <div className="orbs-wrapper">
      <div
        className={classNames('orbs-blurred-background', {
          'impact-ratings-blurred-background': jsonType === 'impact_ratings_module',
        })}
      />
      {jsonType !== 'impact_ratings_module' && (
        <div
          className={classNames('orbs-gradient-background', {
            'quote-orbs': jsonType === 'quote_module',
            'contact-orbs': jsonType === 'contact_module',
          })}
        />
      )}
      {animationData && (
        <LottieWrapper
          options={defaultOptions(animationData)}
          style={{ position: 'absolute' }}
          isClickToPauseDisabled={true}
        />
      )}
      <div className="orbs-children">{children}</div>
    </div>
  );
};

export default OrbsContainer;
